interface FormHeaderProps {
	title: string
	subtitle: string | undefined
}
export const FormHeader = ({ title, subtitle }: FormHeaderProps) => (
	<div className="my-5 self-start text-primary-400">
		<h1 className="text-[1.3rem] font-bold">{title}</h1>
		{subtitle && <h2>{subtitle}</h2>}
	</div>
)
